import { Api, OHIF } from '@gleamer/types';

type PredictionsApi = Api.PredictionsApi;
type UserAuthenticationService = OHIF.UserAuthenticationService;

/**
 * What the preview mode shows instead of a patient's latest predictions: one import's (the Prediction imports page),
 * or a product's current ones, of the whole patient or of one study. Never a task's.
 */
export type PredictionPreview = {
  importId?: number;
  productId?: number;
  studyInstanceUID?: string;
};

export async function fetchPredictions(
  UserAuthenticationService: UserAuthenticationService,
  patientId: string,
  taskId?: number,
  preview?: PredictionPreview,
  /** A task's case: the series it shows, the only ones whose predictions are read (DATAT-662); none, every series. */
  seriesInstanceUIDs: string[] = []
): Promise<PredictionsApi> {
  let response: Response;

  if (!taskId) {
    const query = new URLSearchParams();
    if (preview?.importId !== undefined) {
      query.set('importId', String(preview.importId));
    } else if (preview?.productId !== undefined) {
      query.set('productId', String(preview.productId));
    }
    if (preview?.studyInstanceUID && query.toString()) {
      query.set('studyInstanceUID', preview.studyInstanceUID);
    }
    const suffix = query.toString() ? `?${query}` : '';
    response = await fetch(`/api/predictions/patient/${patientId}${suffix}`, {
      method: 'GET',
      headers: new Headers(UserAuthenticationService.getAuthorizationHeader()),
    });
  } else {
    const query = new URLSearchParams();
    [...new Set(seriesInstanceUIDs)].sort().forEach(uid => query.append('seriesUid', uid));
    const suffix = query.toString() ? `?${query}` : '';
    response = await fetch(`/api/predictions/task/${taskId}/patient/${patientId}${suffix}`, {
      method: 'GET',
      headers: new Headers(UserAuthenticationService.getAuthorizationHeader()),
    });
  }

  if (response.status === 404) {
    console.log(`${response.status} : ${response.statusText}`);
    return {
      patientId,
      predictions: [],
    };
  }
  if (response.status >= 400) {
    throw new Error(`${response.status} : ${response.statusText}`);
  }

  return response.json();
}
